import ThirdPage from "./ThirdPage";
export default ThirdPage;
